var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');

const InlineView = BlockView.extend({
  initialize: function() {
    const regex = /<(block\d+)(.*?)\/>/gi;
    const text = LocaleService.t(this.model.get('text'));
    
    const blockFragments = this.model.get('block-fragments');
    let match;
    let cusor = 0;
    const blocks = [];
    while((match = regex.exec(text)) !== null) {
      if(match.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      let blockStart = match.index;
      let blockEnd = blockStart + match[0].length;
      let preText = text.substring(cusor, blockStart);
      let block = blockFragments[match[1]];
      preText && blocks.push(textBlock(preText));
      block ? blocks.push(block) : blocks.push(textBlock(match[1], true));
      cusor = blockEnd;
    }
    const rem = text.substring(cusor);
    
    if(rem.length > 0) {
      blocks.push(textBlock(rem));
    }
    this.model.set('blocks', blocks);
    
    function textBlock(text, esc) {
      return {
        type: 'text',
        items: [
          {
            description: text,
            escape: esc
          }
        ]
      };
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.renderNestedBlocks(`${this.model.get('cid')}-blocks`, this.model.get('blocks'));
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = InlineView;
